<section class="cz-recommendation-card-dialog-component"
  [ngClass]="{'active': !recommendation.isComplete, 'high': recommendation.priority == 1, 'med': recommendation.priority == 2, 'low': recommendation.priority == 3 }">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-10">
        <h3 class="title"
          *ngIf="getBackupValue('title', recommendation, false)!=='' && getBackupValue('title', recommendation, false)!==null && getBackupValue('title', recommendation, false)!==undefined">
          {{getBackupValue('title', recommendation, false)}}</h3>
        <h3 class="title"
          *ngIf="getBackupValue('title', recommendation, false)==='' || getBackupValue('title', recommendation, false)===null || getBackupValue('title', recommendation, false)===undefined">
          {{'$common_no_translation' | translate}}</h3>
      </div>
      <div class="col-xs-2 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <div class="row middle-xs">
      <div class="col-xs-6">
        <p class="font-size-large no-margin"><span [innerHTML]="'$common_employee' | translate"></span>:
          <cz-user-name-link [user]="recommendation?.subject"></cz-user-name-link>
        </p>
      </div>
      <div class="col-xs-6 end-xs">
        <p class="form-field">
          <!-- Only show the button for completed linked tasks -->
          <button *ngIf="isLinked" (click)="openPdfDialog()" mat-stroked-button color="accent" class="btn-pdf"
            mat-dialog-close [innerHTML]="'$btn_pdf_report' | translate"></button>

          <button *ngIf="canClose || !isReadOnly" (click)="markRecommendationComplete()" mat-flat-button class="link"
            color="accent" mat-dialog-close [innerHTML]="'$btn_mark_complete' | translate"></button>
        </p>
      </div>
    </div>
    <div class="row section">
      <div class="col-xs-4">
        <div class="font-size-small"><span [innerHTML]="'$common_created_by' | translate"></span>:</div>
        <div class="truncate" *ngIf="recommendation?.createdBy.id > 0">
          <cz-user-name-link [user]="recommendation?.createdBy"></cz-user-name-link>
        </div>
        <div class="truncate" *ngIf="recommendation?.createdBy.id < 1">
          {{ recommendation?.createdBy.displayName }}
        </div>
      </div>

      <div class="col-xs-4" *ngIf="!recommendation.isComplete">
        <div class="font-size-small"><span [innerHTML]="'$common_recommended_on' | translate"></span>:</div>
        <div class="due-date">{{ recommendation?.recommendationDate | date:'MM-dd-yyyy' }}</div>
      </div>

      <div class="col-xs-4" *ngIf="recommendation.isComplete">
        <div class="font-size-small"><span [innerHTML]="'$common_completed_date' | translate"></span>:</div>
        <div class="due-date">{{ recommendation?.completedDate | date:'MM-dd-yyyy' }}</div>
      </div>

      <div class="col-xs-4" *ngIf="isReadOnly">
        <div class="font-size-small"><span [innerHTML]="'$common_priority' | translate"></span>:</div>
        <div class="priority-label">
          {{ recommendation?.priorityText }}
        </div>
      </div>

      <div class="col-xs-4" *ngIf="!isReadOnly" [formGroup]="recommendationFormGroup">
        <mat-form-field class="form-full-width-field">
          <mat-label [innerHTML]="'$common_priority' | translate"></mat-label>
          <mat-select formControlName="priorityCtrl" class="priority-label">
            <mat-option *ngFor="let priority of priorities" [value]="priority.value">
              {{priority.viewValue | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row section">
      <div [ngClass]="{'col-xs-8': recommendation.imageFileName, 'col-xs-12': !recommendation.imageFileName}">
        <div class="rec-text-container" *ngIf="descriptionControl.value !== ''">
          <p class="font-size-small"><span [innerHTML]="'$common_description' | translate"></span>:</p>
          <editor [apiKey]="tinyApiKey" [init]="descriptionDisplayConfig" [formControl]="descriptionControl"></editor>
        </div>
        <div class="rec-text-container" *ngIf="descriptionControl.value === ''">
          <p class="font-size-small"><span [innerHTML]="'$common_description' | translate"></span>:</p>
          <p class="font-size-small"> {{'$common_no_translation' | translate}}</p>
        </div>
        <div class="rec-details-container" *ngIf="recommendation.ergoDetails">
          <p class="font-size-small"><span [innerHTML]="'$common_ergonomist_details' | translate"></span>:</p>
          <editor [apiKey]="tinyApiKey" [init]="descriptionDisplayConfig" [formControl]="detailsControl"></editor>
        </div>
      </div>
      <div class="col-xs-4 recommendation-image" *ngIf="recommendation.imageFileName">
        <img [src]="recommendation.imageFileName" />
      </div>
    </div>
  </mat-dialog-content>
  <mat-actions>
    <div class="row end-xs">
      <div class="col-xs-4" *ngIf="!isReadOnly">
        <p><button (click)="updateRecommendation()" mat-flat-button class="link" color="primary" mat-dialog-close
            [innerHTML]="'$btn_save' | translate"></button></p>
      </div>
    </div>
  </mat-actions>
</section>